<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <combo-field slot="pr_brand"
          :label="customLabel.pr_brand || '品牌'"
          v-model="form.main.pr_brand"
          url="/api/document/productbrand/getCombo"
        />
        <div class="weui-cell" slot="pr_detail">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_detail || "产品名称"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.pr_detail" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell" slot="pr_orispeccode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_orispeccode || "型号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.pr_orispeccode"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pr_spec">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_spec || "规格"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.pr_spec" placeholder="请填写" />
          </div>
        </div>
        <combo-field slot="pr_kind"
        :label="customLabel.pr_kind || '类型'"
          v-model="form.main.pr_kind"
          url="/api/document/producttype/getCombo"
        />
        <div
          class="weui-cell weui-cell_select weui-cell_select-after"
          slot="pr_manutype"
        >
          <div class="weui-cell__hd">
            <label for class="weui-label">生产类型</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.pr_manutype"
              placeholder="请选择"
            >
              <option value="MAKE">自制</option>
              <option value="OSMAKE">委外</option>
              <option value="PURCHASE">外购</option>
              <option value="MAKECUT">分切</option>
              <option value="CUSPROVIDE">客供</option>
              <option value="NOT">无</option>
            </select>
          </div>
        </div>
        <combo-field slot="pr_unit"
          :label="customLabel.pr_unit || '单位'"
          v-model="form.main.pr_unit"
          url="/api/document/productunit/getCombo"
        />
        <combo-field slot="pr_unit_extra"
          :label="customLabel.pr_unit_extra || '辅助单位'"
          v-model="form.main.pr_unit_extra"
          @input="onSelestPrUnitExtra"
          url="/api/document/productunit/getCombo"
        />
        <div class="weui-cell" slot="单位换算" v-if="isShow">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{"单位换算"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.main.pr_numerator" placeholder="" />
          </div>
          <div style="font-size: 12px; color: var(--weui-FG-1);">{{ form.main.pr_unit_extra }}</div>
          <div style="margin: 0 10px;">=</div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.main.pr_denominator" placeholder="" />
          </div>
          <div style="font-size: 12px; color: var(--weui-FG-1);">{{ form.main.pr_unit }}</div>
        </div>
        <div class="weui-cell" slot="pr_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_remark || "备注"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.pr_remark"
              placeholder="请填写"
            />
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells_hd">管理信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <vendor-field v-model="form.main.pr_vendname" slot="pr_vendname" @select="onSelectVendor"/>
        <div class="weui-cell" slot="pr_leadtime">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_leadtime || "采购提前期"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pr_leadtime"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="pr_zxbzs">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_zxbzs || "最小包装数"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="number" v-model="form.main.pr_zxbzs" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell" slot="pr_standardprice">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_standardprice || "标准定价(元)"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pr_standardprice"
              placeholder="请填写"
            />
          </div>
        </div>
        <warehouse-field
          slot="pr_whname"
          :label="customLabel.pr_whname || '默认仓库'"
          :pr_kind="form.main.pr_kind"
          v-model="form.main.pr_whname"
          @select="onSelectWarehouse"
        />
        <div class="weui-cell" slot="pr_safetystock">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.pr_safetystock || "安全库存"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pr_safetystock"
              placeholder="请填写"
            />
          </div>
        </div>
        <custom-field 
          :label="customLabel.pr_text1 || '自定义字段1'"
          v-model="form.main.pr_text1" :caller="caller" fieldName="pr_text1"
          slot="pr_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.pr_text2 || '自定义字段2'"
          v-model="form.main.pr_text2" :caller="caller" fieldName="pr_text2"
          slot="pr_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.pr_text3 || '自定义字段3'"
          v-model="form.main.pr_text3" :caller="caller" fieldName="pr_text3"
          slot="pr_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.pr_text4 || '自定义字段4'"
          v-model="form.main.pr_text4" :caller="caller" fieldName="pr_text4"
          slot="pr_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.pr_text5 || '自定义字段5'"
          v-model="form.main.pr_text5" :caller="caller" fieldName="pr_text5"
          slot="pr_text5" hidden="true"
        />
      </custom-layout>
      
      <div class="weui-cells">
        <file-field v-model="form.main.pr_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">保存</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import VendorField from "@/components/field/VendorField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import FileField from "@/components/field/FileField.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    ComboField,
    VendorField,
    WarehouseField,
    FileField,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/product",
      caller: "Product",
      xtype:'document-product-formpanel',
      form: {
        main: {
          pr_kind: "",
          pr_unit: "PCS",
          pr_unit_extra: "",
          pr_numerator: 0,
          pr_denominator: 0,
          pr_leadtime: 0,
          pr_zxbzs: 0,
          pr_standardprice: 0,
          pr_safetystock: 0
        },
        items: []
      }
    };
  },
  computed: {
    isShow() {
      let main = this.form.main
      return main.pr_unit && main.pr_unit_extra && (main.pr_unit != main.pr_unit_extra)
    }
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.pr_detail) {
        me.$weui.topTips("请填写产品名称", 2000);
      } else if (!main.pr_unit) {
        me.$weui.topTips("请选择单位", 2000);
      } else if (main.pr_unit_extra && main.pr_numerator * main.pr_denominator == 0) {
        me.$weui.topTips("单位换算不可以为0", 2000);
      } else {
        me.f_save();
      }
    },
    onSelectVendor(selection) {
      var me = this,
        main = me.form.main;
      main.pr_vendid = selection.id;
      main.pr_vendcode = selection.ve_code;
    },
    onSelectWarehouse(selection) {
      var me = this,
        main = me.form.main;
      main.pr_whid = selection.id;
      main.pr_whcode = selection.wh_code;
    },
    onSelestPrUnitExtra(selection) {
      let main = this.form.main
      if(main.pr_numerator == 0 || main.pr_denominator == 0) {
        main.pr_numerator = 1
        main.pr_denominator = 1
      } else if(selection == main.pr_unit) {
        main.pr_numerator = 1
        main.pr_denominator = 1
      }
    }
  }
};
</script>